import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

const initialState = { value: null };

const mapsApiKey = createSlice({
	name: 'mapsApiKey',
	initialState,
	reducers: {
		mapsApiKeyAdded(state, action) {
			// eslint-disable-next-line no-param-reassign
			state.value = action.payload;
		}
	}
});

export const { mapsApiKeyAdded } = mapsApiKey.actions;

export const useMapsApiKey = () =>
	useSelector((state) => state.mapsApiKey?.value);

export default mapsApiKey.reducer;
